import React, { Component } from 'react';
import swal from 'sweetalert2';
import { Form } from 'react-form';
import { creerCompte } from '../../../App_Code/API';
import { estVide, estEmailValide, estMotdePasseValide } from '../../../App_Code/Utils';
import { MDP_TAILLE_MIN, MDP_TAILLE_MAX } from '../../../App_Data/Consts';
import * as HttpStatus from '../../../App_Data/HttpStatus';
import { AfficherFeedback, Texte, Case } from '../../ChampFormulaire';

function estNonVide(valeur) {
    return !estVide(valeur);
}

const champs = [
    { nom: 'email', fonction: estEmailValide },
    { nom: 'mdp', fonction: estMotdePasseValide },
    { nom: 'confirmation', fonction: estMotdePasseValide },
    { nom: 'nom', fonction: estNonVide },
    { nom: 'prenom', fonction: estNonVide },
];

class PageInscription extends Component {
    constructor(props) {
        super(props);

        this.inputs = {};
        champs.forEach((champ) => {
            this.inputs = { ...this.inputs, [champ.nom]: React.createRef() };
        });
        this.envoyerInput = React.createRef();
    }
    
    componentDidMount() {
        document.title = "Inscription à Gérer-ma-Copro";
    }

    handleSubmit = (submittedValues) => {
        const {
            email, mdp, confirmation, nom, prenom,
        } = submittedValues;
        const { history } = this.props;
        this.envoyerInput.current.disabled = true;
        let valide = true;

        champs.forEach((champ) => {
            const champValide = champ.fonction(submittedValues[champ.nom]);
            AfficherFeedback(this.inputs[champ.nom], champValide);
            valide = valide && champValide;
        });

        const mdpIdentique = mdp === confirmation;
        AfficherFeedback(this.inputs.confirmation, mdpIdentique);

        if (!valide || !mdpIdentique) {
            this.envoyerInput.current.disabled = false;
            return;
        }

        const formDef = {
            Email: email,
            Password: mdp,
            Nom: nom,
            Prenom: prenom,
            Adresse1: '',
            Adresse2: '',
            Cp: '',
            Ville: '',
            Tel: '',
            Mobile: '',
            CivAdh: 0,
        };

        creerCompte(formDef).then((response) => {
            if (response.status === HttpStatus.OK) {
                history.push({
                    pathname: '/Inscription/Valide',
                    search: `email=${encodeURIComponent(email)}`,
                });
            } else {
                swal({
                    type: 'error',
                    title: 'Erreur',
                    text: 'Impossible de créer le compte.',
                    footer: response.data.Message.replace(/["]+/g, ''),
                });
                this.envoyerInput.current.disabled = false;
            }
        });
    };

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <h5 className="card-title">Inscription</h5>
                        <div className="form-group required">
                            <label htmlFor="InscriptionEmail">E-mail</label>
                            <Texte
                                id="InscriptionEmail"
                                field="email"
                                placeholder="E-mail"
                                type="email"
                                refRef={this.inputs.email}
                            />
                            <div className="invalid-feedback">Veuillez renseigner votre e-mail</div>
                        </div>
                        <div className="form-row">
                            <div className="form-group required col-md-6">
                                <label htmlFor="InscriptionMdp">
                                    Mot de passe{' '}
                                    <span
                                        className="fas fa-lightbulb"
                                        title={`Saisissez le mot de passe de votre choix, qui doit être composé de ${MDP_TAILLE_MIN} à ${MDP_TAILLE_MAX} caractères.`}
                                    />
                                </label>

                                <Texte
                                    id="InscriptionMdp"
                                    field="mdp"
                                    placeholder="Mot de passe"
                                    type="password"
                                    refRef={this.inputs.mdp}
                                />
                                <div className="invalid-feedback">
                                    Veuillez saisir un mot de passe (la taille doit être comprise entre {MDP_TAILLE_MIN}{' '}
                                    et {MDP_TAILLE_MAX} caractères)
                                </div>
                            </div>
                            <div className="form-group required col-md-6">
                                <label htmlFor="InscriptionMdpConfirmation">Confirmation</label>
                                <Texte
                                    id="InscriptionMdpConfirmation"
                                    field="confirmation"
                                    placeholder="Confirmation"
                                    type="password"
                                    refRef={this.inputs.confirmation}
                                />
                                <div className="invalid-feedback">Veuillez confirmer votre mot de passe</div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group required col-md-6">
                                <label htmlFor="InscriptionNom">Nom</label>
                                <Texte
                                    id="InscriptionNom"
                                    field="nom"
                                    placeholder="Nom"
                                    autoComplete="off"
                                    type="text"
                                    refRef={this.inputs.nom}
                                    maxLength={24}
                                />
                                <div className="invalid-feedback">Veuillez renseigner votre nom</div>
                            </div>
                            <div className="form-group required col-md-6">
                                <label htmlFor="InscriptionPrenom">Prénom</label>
                                <Texte
                                    id="InscriptionPrenom"
                                    field="prenom"
                                    placeholder="Prénom"
                                    type="text"
                                    refRef={this.inputs.prenom}
                                    maxLength={25}
                                />
                                <div className="invalid-feedback">Veuillez renseigner votre prénom</div>
                            </div>
                        </div>
                        <div className="form-group">
                            <div className="form-check">
                                <Case id="InscriptionAccepter" field="accepter" required />
                                <label className="form-check-label" htmlFor="InscriptionAccepter">
                                    J&apos;accepte{' '}
                                    <a
                                        href="https://www.gerer-ma-copro.fr/conditions-generales-dutilisation/"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                        les conditions générales d&#39;utilisation
                                    </a>.
                                </label>
                                <div className="invalid-feedback">
                                    Veuillez accepter les conditions générales d&#39;utilisation
                                </div>
                            </div>
                        </div>
                        <button type="submit" className="btn btn-block btn-lg btn-success" ref={this.envoyerInput}>
                            Inscription
                        </button>

                                    <a
                                        href="https://www.kel-syndic-360.fr/pdf/GuideInscription-GMC.pdf"
                                        target="_blank"
                                        rel="noreferrer noopener"
                                    >
                                    Guide d'inscription à Gérer-ma-Copro
                                    </a>


                        <div className="alert alert-primary mt-3" role="alert">
                            Les données recueillies dans le cadre de ce formulaire ne seront pas utilisées à des fins
                            commerciales mais uniquement pour vous donner accès au service Gérer-ma-Copro. Conformément
                            à la loi Informatique et Libertés et au Règlement Général sur la Protection des Données
                            (RGPD), vous disposez des droits d’accès, de rectification et de suppression des données
                            personnelles vous concernant que vous pouvez exercer en nous écrivant à rgpd@kel.fr.
                        </div>
                    </form>
                )}
            </Form>
        );
    }
}

export default PageInscription;



// WEBPACK FOOTER //
// ./src/components/Adherent/Inscription/index.js